import { autoRegisterFeature } from '@store/features/factory';
import { userPreferences } from './store/feature';

// Auto-register the feature
autoRegisterFeature(userPreferences);

// Export everything
export * from './store';
export * from './types';
